import { render, staticRenderFns } from "./PostBannerView.vue?vue&type=template&id=38cb7429&scoped=true"
import script from "./PostBannerView.vue?vue&type=script&lang=js"
export * from "./PostBannerView.vue?vue&type=script&lang=js"
import style0 from "./PostBannerView.vue?vue&type=style&index=0&id=38cb7429&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cb7429",
  null
  
)

export default component.exports